import { useTheme } from 'styled-components';

export const PdfIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      className={className}
      width="26"
      height="19"
      viewBox="0 0 26 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="24" height="17" rx="2" fill="white" stroke={theme.secondary.softBlue1} />
      <path
        d="M5.39009 12V6.36H8.02209C8.65675 6.36 9.13675 6.51467 9.46209 6.824C9.79275 7.128 9.95809 7.54667 9.95809 8.08C9.95809 8.608 9.79275 9.02933 9.46209 9.344C9.13675 9.65333 8.65675 9.808 8.02209 9.808H6.63809V12H5.39009ZM6.63809 8.84H7.86209C8.16075 8.84 8.38209 8.77333 8.52609 8.64C8.67542 8.50667 8.75009 8.32 8.75009 8.08C8.75009 7.84 8.67542 7.656 8.52609 7.528C8.38209 7.39467 8.16075 7.328 7.86209 7.328H6.63809V8.84ZM10.7885 12V6.36H12.9405C13.5965 6.36 14.1512 6.472 14.6045 6.696C15.0579 6.92 15.3992 7.24267 15.6285 7.664C15.8632 8.08 15.9805 8.584 15.9805 9.176C15.9805 9.76267 15.8632 10.2667 15.6285 10.688C15.3992 11.1093 15.0579 11.4347 14.6045 11.664C14.1512 11.888 13.5965 12 12.9405 12H10.7885ZM12.0365 10.976H12.8685C13.4979 10.976 13.9645 10.8293 14.2685 10.536C14.5779 10.2373 14.7325 9.784 14.7325 9.176C14.7325 8.56267 14.5779 8.10933 14.2685 7.816C13.9645 7.52267 13.4979 7.376 12.8685 7.376H12.0365V10.976ZM16.9604 12V6.36H20.7924V7.328H18.2084V8.704H20.6084V9.664H18.2084V12H16.9604Z"
        fill={theme.secondary.softBlue1}
      />
    </svg>
  );
};
